/* =========================== Credentials =========================== */
// Production enviroment
// const bucketName = "my-scouter";
// const bucketRegion = "us-east-2";
// const IdentityPoolId = "us-east-2:06c43050-0cd7-4a0c-bab0-9020900f2b77";

// Develop enviroment
const bucketName = process.env.VUE_APP_AMAZON_BUCKET_NAME;
const bucketRegion = process.env.VUE_APP_AMAZON_BUCKET_REGION;
const IdentityPoolId = process.env.VUE_APP_AMAZON_IDENTITY_POOL_ID;

/* =========================== AWS Object =========================== */
const AWS = require("aws-sdk");

AWS.config.update({
  region: bucketRegion,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: IdentityPoolId,
  }),
});

/* ============================ s3 Object ============================ */
const s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: {
    Bucket: bucketName,
  },
});

module.exports = { AWS, s3, bucketName };
